import { assignInlineVars } from '@vanilla-extract/dynamic'
import clsx from 'clsx'
import { useEffect, useRef, useState } from 'react'
import { Button } from '../../atoms'
import type { ButtonProps } from '../../atoms/Button'
import * as styles from './index.css'

export const ButtonHoldToConfirm = (
  props: {
    delay?: number
    onConfirm: () => void
  } & ButtonProps,
) => {
  const { delay = 1_000, onConfirm, ...buttonProps } = props
  const [percentage, setPercentage] = useState(0)
  const startTime = useRef<number | null>(null)
  const holdIntervalRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    return () => {
      if (holdIntervalRef.current) {
        clearInterval(holdIntervalRef.current)
      }
    }
  }, [])

  const startCounter = () => {
    if (holdIntervalRef.current || props.disabled) return

    startTime.current = Date.now()
    holdIntervalRef.current = setInterval(() => {
      if (startTime.current) {
        setPercentage(((Date.now() - startTime.current) / delay) * 100)
        if (Date.now() - startTime.current > delay) {
          stopCounter()
          onConfirm()
        }
      }
    }, 10)
  }

  const stopCounter = () => {
    startTime.current = null
    setPercentage(0)
    if (holdIntervalRef.current) {
      clearInterval(holdIntervalRef.current)
      holdIntervalRef.current = null
    }
  }

  return (
    <Button
      {...buttonProps}
      onMouseDown={startCounter}
      onMouseUp={stopCounter}
      onMouseLeave={stopCounter}
      onTouchStart={startCounter}
      onTouchCancel={stopCounter}
      onTouchEnd={stopCounter}
      className={clsx(props.className, styles.button)}
      style={assignInlineVars({
        [styles.percentageVar]: `${percentage}`,
      })}
    >
      <div className={styles.children}>{props.children}</div>
    </Button>
  )
}
